import { useCallback, useEffect, useState } from "react";
import { fetchBatchRemainingQuota } from "../services/batchApi";
import { quotaFromResponse, type BatchQuota } from "../utils/batchQuota";

/**
 * 老師的批次上傳每日剩餘次數（kanban 1000892，比照國中）。
 * 載入時查一次；送出成功後、或要依它擋人之前，呼叫 refresh() 重查——計數是國中高中
 * 共用、另一個分頁也會扣，只信載入時那一次會拿過期的數字擋錯人。
 */
export const useBatchQuota = (creatorId: string | undefined) => {
  const [quota, setQuota] = useState<BatchQuota>({ state: "loading" });
  const refresh = useCallback(async (): Promise<BatchQuota> => {
    if (!creatorId) {
      const next: BatchQuota = { state: "unknown" };
      setQuota(next);
      return next;
    }
    try {
      const next = quotaFromResponse(await fetchBatchRemainingQuota(creatorId));
      setQuota(next);
      return next;
    } catch {
      const next: BatchQuota = { state: "unknown" };
      setQuota(next);
      return next;
    }
  }, [creatorId]);
  useEffect(() => {
    void refresh();
  }, [refresh]);
  return { quota, refresh };
};
